import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, filter) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/ServiceDestinations/List`, method: 'POST', body: filter, token: token })
}
